// convert millimoles per liter to milligrams per deciliter
export function mmollToMgdl(n: number): number {
  return n / 0.0555
}
